/* eslint-disable no-irregular-whitespace */
import React, {memo, useCallback, useState} from "react";
import styles from "./ChannelVideoCard.module.css";
import {Link, useNavigate} from "react-router-dom";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../components/elements/PuiTypography";
import {Video} from "../../../stores/program/model/Program";
import CaptionIcon from "../images/CaptionIcon";
import ViewCountIcon from "../images/ViewCountIcon";
import HorizonNewIcon from "../images/HorizonNewIcon";
import SlideButton from "../images/SlideButton";
import SlideButtonFocus from "../images/SlideButtonFocus";
import {format} from "date-fns";

interface ChannelVideoCardProps {
  video: Video;
}

function ChannelVideoCard({video}: ChannelVideoCardProps) {
    const navigate = useNavigate();
    const goToVideo = useCallback(
        () => navigate(`/video/${video.hash}`),
        [navigate, video.hash]
    );

    const [isSlideButtonFocus, setIsSlideButtonFocus] = useState<boolean>(false);

    return (
        <div
            key={`ChannelVideoCard-${video.id}`}
            className={styles.card}
            onClick={goToVideo}
        >
            <div className={styles.thumbnaildiv}>
                <img
                    className={styles.thumbnail}
                    src={video.imageUrl}
                    alt={video.title}
                />
            </div>

            {(video.visibleNewIcon || video.publicCaption || video.SlideFlg) && (
                <div className={styles.statusBar}>
                    <div className={styles.statusIcon}>
                        {video.visibleNewIcon && (
                            <div className={styles.newIcon}>
                                <HorizonNewIcon/>
                            </div>
                        )}
                        {video.publicCaption && (
                            <div className={styles.captionIcon}>
                                <CaptionIcon/>
                            </div>
                        )}
                    </div>
                    {video.SlideFlg && (
                        <div
                            className={styles.slideIcon}
                            onMouseEnter={() => setIsSlideButtonFocus(true)}
                            onMouseLeave={() => setIsSlideButtonFocus(false)}
                        >
                            {!isSlideButtonFocus && <SlideButton/>}
                            {isSlideButtonFocus && <SlideButtonFocus/>}
                        </div>
                    )}
                </div>
            )}

            <div
                style={
                    video.visibleNewIcon || video.publicCaption || video.SlideFlg
                        ? {}
                        : {marginTop: "10px"}
                }
            >
                <div className={styles.title}>
                    <div
                        style={{
                            width: video.publicCaption ? "calc(100% - 55px)" : "100%"
                        }}
                    >
                        <Link to={`/video/${video.hash}`}>
                            <div
                                className={styles.cardTitle}
                                data-for="listtitle"
                                data-tip={video.title}
                            >
                                <PuiTypography size={16} bold={true}>
                                    {video.title}
                                </PuiTypography>
                            </div>
                            <PuiTooltip id="listtitle"/>
                            <div
                                className={styles.cardDescription}
                                data-for="listdes"
                                data-tip={video.description}
                            >
                                <PuiTypography size={14} rows={2} bold={true}>
                                    {video.description}
                                </PuiTypography>
                            </div>
                            <PuiTooltip id="listdes"/>
                        </Link>
                    </div>
                </div>

                <hr
                    className={styles.line}
                    style={
                        video.visibleNewIcon || video.publicCaption || video.SlideFlg
                            ? {marginTop: "15px"}
                            : {marginTop: "32px"}
                    }
                />

                <div
                    className={styles.cardPresenter}
                    data-for="listpresenter"
                    data-tip={video.presenter}
                >
                    <PuiTypography size={14} color={"gray-42"} bold={true}>
                        {video.presenter}
                    </PuiTypography>
                </div>
                <PuiTooltip id="listpresenter"/>

                <div className={styles.meta}>
                    <div className={styles.viewCount}>
                        <ViewCountIcon/>
                    </div>
                    <PuiTypography size={14} color={"gray-42"}>
                        {`${video.viewCount}回視聴　・　${
                            video.updated
                                ? format(
                                    Date.parse(String(video.updated).split("T")[0]),
                                    "yyyy年MM月dd日"
                                )
                                : "不明"
                        }`}
                    </PuiTypography>
                </div>
            </div>
        </div>
    );
}

export default memo(ChannelVideoCard);
